import { render, staticRenderFns } from "./externalUrlComponent.vue?vue&type=template&id=7dc39a22&scoped=true"
import script from "./externalUrlComponent.vue?vue&type=script&lang=js"
export * from "./externalUrlComponent.vue?vue&type=script&lang=js"
import style0 from "./externalUrlComponent.vue?vue&type=style&index=0&id=7dc39a22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc39a22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc39a22')) {
      api.createRecord('7dc39a22', component.options)
    } else {
      api.reload('7dc39a22', component.options)
    }
    module.hot.accept("./externalUrlComponent.vue?vue&type=template&id=7dc39a22&scoped=true", function () {
      api.rerender('7dc39a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/externalUrlComponent.vue"
export default component.exports